import { addMinutes } from 'date-fns'

/**
 * Calcula os horários finais disponíveis para agendamento, a partir dos horários
 * iniciais ocupados/livres da agenda e do horário inicial já escolhido.
 *
 * @param slotsDaAgenda Horários da agenda, indexados pelo horário inicial de cada slot.
 * **Precisa estar ordenado por chave (horário) crescente**.
 * @param horarioInicialSelecionado Horário inicial selecionado.
 * @param proximoHorarioOcupado Horário do próximo agendamento ocupado, se houver. Horários a partir
 * dele (inclusivo) são excluídos do resultado. Se `undefined`, todos os horários a partir de
 * `horarioInicialSelecionado` são considerados.
 * @param duracaoMaximaMinutos Duração máxima, em minutos, permitida para o agendamento. Horários finais
 * que ultrapassem esse limite são excluídos do resultado. Se `undefined`, nenhum limite é aplicado.
 * @returns Lista ordenada de horários finais possíveis.
 */
export const getItemsHorarioFinal = (
  slotsDaAgenda: Map<Date, { duracao: number }>,
  horarioInicialSelecionado: Date,
  proximoHorarioOcupado: Date | undefined,
  duracaoMaximaMinutos?: number
): Date[] => {
  const inicioEmMs = Number(horarioInicialSelecionado)
  const limitePorOcupacaoEmMs = proximoHorarioOcupado ? Number(proximoHorarioOcupado) : Infinity
  const limitePorDuracaoMaximaEmMs =
    duracaoMaximaMinutos !== undefined ? Number(addMinutes(horarioInicialSelecionado, duracaoMaximaMinutos)) : Infinity

  const horariosFinaisDisponiveis: Date[] = []
  for (const [inicioDoSlot, { duracao }] of slotsDaAgenda) {
    const inicioDoSlotEmMs = Number(inicioDoSlot)
    if (inicioDoSlotEmMs < inicioEmMs) continue
    if (inicioDoSlotEmMs >= limitePorOcupacaoEmMs) break

    const fimDoSlot = addMinutes(inicioDoSlot, duracao)
    if (Number(fimDoSlot) > limitePorDuracaoMaximaEmMs) break

    horariosFinaisDisponiveis.push(fimDoSlot)
  }

  return horariosFinaisDisponiveis
}
